import React, { useEffect, useRef, useState } from 'react';
import TypedText from "components/Homes/typewrite";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import './StoriesTeam.css'
import { getCareerLifeAtHrepl } from 'components/Service/CareerApi';
import Typewriter from 'typewriter-effect';
const LIFE_AT_HREPL_UUID = "3e737260-60b9-4211-9e5e-f1f9d09e9fd1";


const testimonials = [
  {
    id: 1,
    name: "Avinash Mishra",
    role: "Procurement Champion",
    image: "assets/img/career/new/saven-patel.webp",
    quote: "When I joined renewables energy three years ago, I was employee # 38. Today I am part of force scaling towards a 10 GW future."
  },
  {
    id: 2,
    name: "Vaishnavi Chandel",
    role: "Financial Analyst",
    image: "assets/img/career/new/vaishnavi-chandel.webp",
    quote: "I joined as a fresher then and now I have come long way rapidly moving independently to Managing external stakeholders."
  }
];

export default function TeamStories() {

        const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkScreen = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      checkScreen();
      window.addEventListener("resize", checkScreen);
  
      return () => window.removeEventListener("resize", checkScreen);
    }, []);  
          const [slides, setSlides] = useState<any>([]);
        
          useEffect(() => {
            const fetchData = async () => {
              try {
                const res = await getCareerLifeAtHrepl(LIFE_AT_HREPL_UUID);
        
                setSlides(res);
              } catch (err) {
                console.error("Failed to fetch Life @ HREPL", err);
                setSlides([]);
              }
            };
        
            fetchData();
          }, []);
        
    const swiperRefs = useRef<any[]>([]);
    const prevRefs = useRef<any[]>([]);
    const nextRefs = useRef<any[]>([]);
  
    // ✅ separate counters per swiper
    const [activeGroups, setActiveGroups] = useState<any>({});
    const [totalGroups, setTotalGroups] = useState<any>({});
  
    // ✅ Counter update
    const updateCounter = (swiper: any, index: number) => {
      if (!swiper) return;
  
      const slidesPerGroup = swiper.params.slidesPerGroup || 1;
  
      const realSlidesCount = swiper.slides.filter(
        (slide: any) => !slide.classList.contains("swiper-slide-duplicate"),
      ).length;
  
      const currentGroup = Math.floor(swiper.realIndex / slidesPerGroup) + 1;
  
      const total = Math.ceil(realSlidesCount / slidesPerGroup);
  
      setActiveGroups((prev: any) => ({
        ...prev,
        [index]: currentGroup,
      }));
  
      setTotalGroups((prev: any) => ({
        ...prev,
        [index]: total,
      }));
    };
     if (!slides) return null;
   
  return (
    <section id='section-diversity' className={`testimonial-section  d-flex position-relative flex-column justify-content-center overflow-hidden career-section ${slides?.status ? '' : 'd-none'}`} >
      {/* Background Decorative Grid */}
      {/* //<div className="bg-grid-accent position-absolute" /> */}
       <div className='career-stories-team-top-background' />
  
      <div className="container ">
        {/* Section Header */}
        <div
          className="section-title  text-center mx-auto mb-5 wow fadeInUp clearfix"
          data-wow-delay="0.4s"  style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
        >
          <h6>  {slides?.subtitle || ""}</h6>
          <h2 className="mb-4 ">
            {slides?.title || ""}
             {/* <Typewriter
                                          key={1}
                                          onInit={(typewriter: any) => {
                                            typewriter
                                              .deleteAll(1) // 🔥 removes previous text instantly
                                              .typeString( slides?.title || "").start();
                                          }}
                                          options={{
                                            delay: 100, // slow typing
                                            cursor: "",
                                          }}
                                        /> */}
            {/* <TypedText
              index={1}
              text={`<span class='text-dark'>${slides?.title} </span>`}
              delay={100}
              cursor="|"
            /> */}
          </h2>
        </div>

        {/* Testimonials Grid Layout */}
        <div className=" justify-content-center" >
          {testimonials.map((item) => (
            <div key={item.id} className="col-12 col-xl-6 d-none">
              <div className="d-flex flex-column flex-md-row gap-4 align-items-start h-100">
                {/* Profile Image Asset Container */}
                <div className="profile-img-wrap flex-shrink-0 mx-auto mx-md-0">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-100 h-100 object-cover"
                  />
                </div>

                {/* Content Area */}
                <div className="d-flex flex-column justify-content-between h-100 pt-1">
                  <div>
                    {/* SVG Quotation Mark component scaled to replicate design asset */}
                    <div className="quote-mark mb-2">“</div>
                    <p
                      className="text-secondary mb-4 lh-base"
                      style={{ fontSize: "0.95rem", fontWeight: "500" }}
                    >
                      {item.quote}
                    </p>
                  </div>

                  {/* Underlined Name Footer */}
                  <div className="name-accent-bar pb-3">
                    <h4
                      className="h5 mb-1 fw-bold"
                      style={{ color: "#1a1a1a" }}
                    >
                      {item.name}
                    </h4>
                    <span
                      className="text-muted text-uppercase fw-semibold"
                      style={{ fontSize: "0.72rem", letterSpacing: "0.5px" }}
                    >
                      {item.role}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}

          {slides?.items?.length > 0 && (
            <Swiper
              modules={[Navigation]}
              navigation={false} // ✅ MUST ENABLE
              loop={false}
             // autoplay={{ delay: 8000, disableOnInteraction: false }} // ✅ autoplay working
              slidesPerView={1}
              spaceBetween={30}
              breakpoints={{
                0: { slidesPerView: 1, slidesPerGroup: 1 },
                768: { slidesPerView: 1, slidesPerGroup: 1 },
                992: { slidesPerView: 2, slidesPerGroup: 1 },
              }}
              onSwiper={(swiper: any) => {
                swiperRefs.current[0] = swiper;

                setTimeout(() => {
                  const prevEl = prevRefs.current[0];
                  const nextEl = nextRefs.current[0];

                  if (!swiper || !swiper.params) return;
                  if (!prevEl || !nextEl) return;

                  // ✅ assign navigation safely
                  swiper.params.navigation.prevEl = prevEl;
                  swiper.params.navigation.nextEl = nextEl;

                  // ✅ re-init navigation
                  swiper.navigation.destroy();
                  swiper.navigation.init();
                  swiper.navigation.update();
                }, 100);
              }}
              onSlideChange={(swiper: any) => updateCounter(swiper, 0)}
              className="career-swiper" data-wow-delay="0.9s" style={{
                animation: 'fadeInMiddle 0.8s ease-in-out both',
              }}
            >
              {slides?.items?.map((item: any, index: any) => {
                return (
                  <SwiperSlide key={index}>
                    <div key={index} className="col-12 col-xl-12 ">
                      <div className="d-flex flex-column flex-md-row gap-4 align-items-end h-100">
                        {/* Profile Image Asset Container */}
                        <div className="profile-img-wrap flex-shrink-0 mx-auto mx-md-0">
                          <img
                            src={item.image}
                            alt={item.imageAlt}
                            className="w-100 h-100 object-cover"
                          />
                        </div>

                        {/* Content Area */}
                        <div className="d-flex flex-column justify-content-between h-100 pt-1 name-accent-bar">
                          <img src="assets/img/career/quote-mark.webp" alt="quote-mark" width={40} className="img-fluid mb-3 mt-3 mt-md-0 mt-lg-0" />
                            <i className="fa fa-quote-left fa-3x d-none  text-primary mb-4 mt-3 mt-md-0 mt-lg-0"></i>
                          <div   dangerouslySetInnerHTML={{
                              __html: item.description,
                            }} />
                          
                        </div>
                      </div>
                    </div>
                  
                  </SwiperSlide>
                );
              })}

        
          {/* {totalGroups[0] > 1 && ( */}
                <div className={`d-flex justify-content-center  align-items-center gap-4 mt-5 ${totalGroups[0] === 0 ? 'd-none' : ''}`}>
                  <span
                    ref={(el: any) => (prevRefs.current[0] = el)}
                    className="cursor-pointer swiper-arrow btn nav-circle-btn shadow-none"
                  >
                     <i className="bi bi-chevron-left"></i>
                  </span>

                  <div className="fw-semibold d-none">
                    {activeGroups[0] || 1} / {totalGroups[0] || 1}
                  </div>

                  <span
                    ref={(el: any) => (nextRefs.current[0] = el)}
                    className="cursor-pointer swiper-arrow btn nav-circle-btn shadow-none"
                  >
                    <i className="bi bi-chevron-right"></i>
                  </span>
                </div>
            {/* )} */}
            </Swiper>
          )}

             
                {/* {totalGroups[0] > 1 && (
                <div className="d-flex justify-content-center d-none gap-3 mt-5 pt-4">
          <span className="btn nav-circle-btn shadow-none" ref={(el: any) => (prevRefs.current[0] = el)} aria-label="Previous">
            <i className="bi bi-chevron-left"></i>
          </span>
          <span className="btn nav-circle-btn shadow-none" ref={(el: any) => (nextRefs.current[0] = el)} aria-label="Next">
            <i className="bi bi-chevron-right"></i>
          </span>
        </div>  )} */}
        

          {/* Dynamic Carousel Navigation Arrows */}
        </div>
      </div>
      {/* Corporate Green Accent Strip Line */}
    </section>
  );
}